var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { parseThemePath } from '@axs/axsui-theme';
var Content = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  list-style: none;\n  border: none;\n  background-color: transparent;\n  padding: ", ";\n  width: ", ";\n  text-transform: ", ";\n  border-radius: ", ";\n  -webkit-appearance: none;\n  --moz-appearance: none;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:focus-visible {\n    box-shadow: ", ";\n  }\n\n  & * {\n    cursor: ", ";\n    opacity: ", ";\n  }\n"], ["\n  cursor: ", ";\n  list-style: none;\n  border: none;\n  background-color: transparent;\n  padding: ", ";\n  width: ", ";\n  text-transform: ", ";\n  border-radius: ", ";\n  -webkit-appearance: none;\n  --moz-appearance: none;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:focus-visible {\n    box-shadow: ", ";\n  }\n\n  & * {\n    cursor: ", ";\n    opacity: ", ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default !important' : 'pointer !important');
}, function (_a) {
    var padding = _a.padding;
    return (padding ? padding : '0 16px 6px;');
}, function (_a) {
    var tabWidth = _a.tabWidth;
    return (tabWidth ? tabWidth : 'auto');
}, function (_a) {
    var textTransform = _a.textTransform;
    return (textTransform ? textTransform : 'uppercase');
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return borderRadius && borderRadius;
}, function (_a) {
    var theme = _a.theme;
    return "0 0 0 2px ".concat(parseThemePath('axsui.forms.outlineColor', theme, '#007def'));
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '.5' : '1');
});
export var AXSTab = function (_a) {
    var active = _a.active, disabled = _a.disabled, onClick = _a.onClick, children = _a.children, className = _a.className, textTransform = _a.textTransform, borderRadius = _a.borderRadius, padding = _a.padding, props = __rest(_a, ["active", "disabled", "onClick", "children", "className", "textTransform", "borderRadius", "padding"]);
    var classes = ['c-axs-tab', 'c-axs-menu__tab', { 'c-axs-tab--active': active }, className];
    return (React.createElement(Content, { onClick: function (e) { return (!disabled && props ? onClick(e, props) : null); }, className: classnames(classes), active: active, disabled: disabled, role: "menuitem", textTransform: textTransform, borderRadius: borderRadius, padding: padding },
        React.createElement("span", null, children)));
};
var templateObject_1;
